import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios-title" className="w-full bg-cream-200 px-5 py-20 sm:py-24" data-id="element-149" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-content" data-id="element-150" data-mp="3fz5mzurn5ef7">
        <h2 id="testimonios-title" className="max-w-xl text-center font-display text-4xl font-semibold leading-tight tracking-tight text-plum-800 sm:text-left sm:text-5xl" data-id="element-151" data-mp="3fxuni758astw">
          Lo que dicen las mujeres que ya tienen el sistema
        </h2>

        <div className="mt-12 grid gap-x-10 gap-y-10 sm:grid-cols-2" data-id="element-152" data-mp="31z3ako23rd7c">
          {testimonials.map(item => <figure key={item.author} className="flex h-full flex-col border-t border-rose-200 pt-6" data-id="element-153" data-mp="2x1bi9sxjpp2m">
              <blockquote className="font-display text-2xl italic leading-snug text-plum-700" data-id="element-154" data-mp="2s39syq9j0tip">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-5 text-xs font-semibold uppercase tracking-[0.16em] text-rose-500" data-id="element-155" data-mp="q9tzllm210k1">
                {item.author} — {item.place}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}